import { plural, t } from '@lingui/core/macro'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import type { FileActionContext } from '@jotta/types/FileActions'
import { observer } from 'mobx-react-lite'
import type { FolderStore } from '../Folder/FolderStore'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@jotta/ui/DropdownMenu'
import SvgBoldMoreHorisontal from '@jotta/ui/SvgBoldMoreHorisontal'

export const SelectionActions = observer(function SelectionActions({
  folder,
}: {
  folder: FolderStore
}) {
  const { actions, selectedActions, oneSelected, selectedChildren } = folder

  const selectedFiles = selectedChildren.filter(c => c.isFile).length
  const selectedFolders = selectedChildren.filter(c => c.isFolder).length

  let selectionText = ''
  if (selectedFiles + selectedFolders === 1) {
    selectionText = selectedChildren[0].name
  } else {
    if (selectedFolders) {
      const count = selectedFolders
      selectionText = plural(count, { one: '# folder', other: '# folders' })
    }
    if (selectedFiles && selectedFolders) {
      selectionText += ` ${t`and`} `
    }
    if (selectedFiles) {
      const count = selectedFiles
      selectionText += plural(count, { one: '# file', other: '# files' })
    }
  }

  const selectionActionContext: FileActionContext = oneSelected
    ? 'FOLDER_LIST'
    : 'SELECTION'
  const selectionActionPath = selectedChildren.at(0)?.path || ''

  // useEffect(() => {
  //   selection.setIndeterminate(indeterminate)
  // }, [selection, indeterminate])

  const primaryActionNames = new Set(['Download', 'Share'])
  const primaryActions = selectedActions.filter(a =>
    primaryActionNames.has(a.action),
  )
  const menuActions = selectedActions.filter(
    a => !primaryActionNames.has(a.action),
  )

  return (
    <div className="flex h-full grow items-center justify-between gap-3 pl-1">
      <span className="label-sm min-w-0 flex-1 truncate" title={selectionText}>
        {selectionText}
      </span>
      <div className="flex shrink-0 items-center gap-2">
        {primaryActions.map(a => (
          <button
            className="btn btn-outline"
            key={a.name}
            data-select-action={a.action}
            onClick={() => {
              actions.dispatch(
                a.action,
                selectionActionContext,
                selectionActionPath,
              )
            }}
          >
            <PlainBrandIcon className="w-6" icon={a.icon} />
            <span className="hidden xl:block">{a.name}</span>
          </button>
        ))}

        {menuActions.length > 0 && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="btn btn-outline data-[state=open]:bg-surface-container-low"
                aria-label="More actions"
              >
                <PlainBrandIcon className="w-6" icon={SvgBoldMoreHorisontal} />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {menuActions.map(a => (
                <DropdownMenuItem
                  key={a.name}
                  onSelect={() =>
                    actions.dispatch(
                      a.action,
                      selectionActionContext,
                      selectionActionPath,
                    )
                  }
                >
                  <PlainBrandIcon className="w-6" icon={a.icon} />
                  <span>{a.name}</span>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </div>
  )
})
